module.exports = __webpack_public_path__ + "img/notification.626a2df5.svg";